import { z } from "zod";

export const BRIDGE_URL = "https://nbhjcrhsjyfcsahcipqs.supabase.co";
export const BRIDGE_KEY = "sb_publishable_KlwwxefC89F5txLZUYVRog_ZjwS0HRx";
export const navSchema = z.object({
  command_id: z.string().min(1).max(100), issued_at: z.string().datetime(),
  target: z.enum(["industry", "client", "contact", "follow_up", "reminder", "task", "prospect", "trade_show", "campaign", "module", "pipeline", "map", "planning"]),
  id: z.string().min(1).max(100).optional(), industry: z.string().min(1).max(200).optional(),
  module: z.string().min(1).max(100).optional(), label: z.string().max(200).optional(),
});
export type NavCommand = z.infer<typeof navSchema>;
export const moduleRoutes: Record<string, string> = {
  dashboard: "/index", clients: "/index", contacts: "/contacts", pipeline: "/stages", stages: "/stages",
  "follow-ups": "/index", follow_ups: "/index", reminders: "/index", tasks: "/index", todos: "/index",
  "weekly log": "/weeks", weekly_log: "/weeks", weeks: "/weeks", prospecting: "/prospecting", prospects: "/prospecting",
  "trade-shows": "/trade-shows", trade_shows: "/trade-shows", "trade shows": "/trade-shows",
  campaigns: "/communicator", communicator: "/communicator", imports: "/contacts", reports: "/reports",
  map: "/mapping", mapping: "/mapping", planning: "/planning",
};
export const recordTables = {
  client: "clients", contact: "company_contacts", follow_up: "follow_ups", reminder: "reminds",
  task: "todos", prospect: "prospects", trade_show: "trade_shows", campaign: "campaigns",
} as const;
export function acceptCommand(payload: unknown, follow: boolean, visible: boolean, seen: Set<string>, now = Date.now()): NavCommand | null {
  const result = navSchema.safeParse(payload);
  if (!follow || !visible || !result.success) return null;
  const cmd = result.data;
  const age = now - Date.parse(cmd.issued_at);
  if (age < 0 || age > 60_000 || seen.has(cmd.command_id)) return null;
  if (cmd.target === "industry" && !cmd.industry) return null;
  if (cmd.target in recordTables && !cmd.id) return null;
  if (cmd.target === "module" && !moduleRoutes[cmd.module?.trim().toLowerCase() ?? ""]) return null;
  seen.add(cmd.command_id);
  if (seen.size > 200) { const oldest = seen.values().next().value; if (oldest) seen.delete(oldest); }
  return cmd;
}
export function commandRoute(cmd: NavCommand): string {
  if (cmd.target === "module") return moduleRoutes[cmd.module?.trim().toLowerCase() ?? ""];
  if (cmd.target === "pipeline") return "/stages";
  if (cmd.target === "map") return "/mapping";
  if (cmd.target === "planning") return "/planning";
  if (cmd.target === "prospect") return "/prospecting";
  if (cmd.target === "trade_show") return "/trade-shows";
  if (cmd.target === "campaign") return "/communicator";
  return "/index";
}
export function refreshTables(table: string): string[] {
  if (["clients", "company_contacts", "client_industries", "client_stages", "industries"].includes(table)) return [table, "clients", "company_contacts", "client_stages", "industries", "reminds"];
  if (["follow_ups", "reminds"].includes(table)) return ["follow_ups", "reminds", "clients"];
  return [table];
}